module.exports = __webpack_public_path__ + "static/media/TripleBellVibes.d0447550.mp3";